import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaWhatsapp, FaInstagram } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-wrapper">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-list">
              <li><Link to='/about' className="footer-link">About Us</Link></li>
              <li><Link className="footer-link">Tracking</Link></li>
              <li><Link className="footer-link">Privacy Policy</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3 className="footer-title-logo">XANOMEGA</h3>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-social">
            <Link to="https://www.facebook.com" className="social-link">
                <FaFacebook className="social-icon" />
            </Link>
            <Link to="https://l.instagram.com/?u=https%3A%2F%2Fwa.me%2Fmessage%2FR5X52VJUNSXFD1&e=AT3hpQtfxKHueD6kAf8vIqcIDOoX81IeHCTga9eZLdzjeGHvc8Q44FAOKA1oNobEytDNdkUS-TLMUEpn1pcGyjDVMttzhFrfCbbfFw" className="social-link">
                <FaWhatsapp className="social-icon" />
            </Link>
            <Link to="https://www.instagram.com/xangrp/?utm_source=ig_web_button_share_sheet" className="social-link">
                <FaInstagram className="social-icon" />
            </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} XAN OMEGA. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;